module.exports = __webpack_public_path__ + "static/img/13.3658ddf5.png";